// ===== Nav: solidify on scroll (always solid on sub-pages w/o full-bleed hero) =====
const nav = document.getElementById('nav');
const isHome = !!document.querySelector('#awear-root .hero');
const onScroll = () => nav.classList.toggle('nav--solid', isHome ? window.scrollY > 60 : true);
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });

// ===== Mobile menu =====
const toggle = document.getElementById('navToggle');
toggle.addEventListener('click', () => {
  const open = nav.classList.toggle('nav--open');
  nav.classList.add('nav--solid');
  toggle.setAttribute('aria-expanded', open);
});
nav.querySelectorAll('.nav__links a').forEach(a =>
  a.addEventListener('click', () => {
    nav.classList.remove('nav--open');
    toggle.setAttribute('aria-expanded', false);
  })
);

// ===== Scroll reveal =====
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Reveal above-the-fold heroes immediately (no fade-from-blank; consistent LCP across pages).
// The news grid is the page's main content but sits below a tall hero, so reveal it on load too
// (keeps the fade-in animation, drops the scroll requirement).
requestAnimationFrame(() =>
  document.querySelectorAll('.hero .reveal, .phero .reveal, .news-grid').forEach(el => el.classList.add('in'))
);
// Safety: if IntersectionObserver is unavailable, never leave content hidden
if (!('IntersectionObserver' in window)) {
  document.querySelectorAll('.reveal').forEach(el => el.classList.add('in'));
}

// ===== Sticky order bar (product page): show once past the hero, hide while the buy box is on screen =====
const buybar = document.querySelector('.buybar');
const buyEl = document.querySelector('#buy');
if (buybar && buyEl) {
  const heroEl = document.querySelector('.phero');
  const syncBar = () => {
    const buyR = buyEl.getBoundingClientRect();
    const heroBottom = heroEl ? heroEl.getBoundingClientRect().bottom : -1;
    const pastHero = heroBottom < 60;                                  // hero scrolled (nearly) out of view
    const buyInView = buyR.bottom > 90 && buyR.top < window.innerHeight; // configurator overlaps the viewport
    buybar.classList.toggle('is-visible', pastHero && !buyInView);
  };
  window.addEventListener('scroll', syncBar, { passive: true });
  window.addEventListener('resize', syncBar, { passive: true });
  syncBar();
}

// ===== Stat count-up =====
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const animateCount = (el) => {
  const target = +el.dataset.count;
  const suffix = el.parentElement.querySelector('.stat__suffix');
  if (suffix) suffix.style.display = 'inline';
  if (reduce) { el.textContent = target; return; }
  const dur = 1400, start = performance.now();
  const tick = (now) => {
    const p = Math.min((now - start) / dur, 1);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(target * eased);
    if (p < 1) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
};
const statIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) { animateCount(e.target); statIO.unobserve(e.target); }
  });
}, { threshold: 0.6 });
document.querySelectorAll('.stat__n[data-count]').forEach(el => statIO.observe(el));

// ===== FAQ: single-open accordion =====
const faqs = document.querySelectorAll('.qa');
faqs.forEach(d => d.addEventListener('toggle', () => {
  if (d.open) faqs.forEach(o => { if (o !== d) o.open = false; });
}));

// ===== Order: bundle configurator =====
const buy = document.querySelector('.buy');
if (buy) {
  const segs = buy.querySelectorAll('.seg');
  const sets = buy.querySelectorAll('.buy__set');
  const totalEl = buy.querySelector('[data-total]');
  const cta = buy.querySelector('[data-cta]');
  const selectOpt = (opt) => {
    opt.closest('.buy__set').querySelectorAll('.opt')
      .forEach(o => o.classList.toggle('is-on', o === opt));
    const price = opt.dataset.price;
    totalEl.textContent = '$' + price;
    cta.textContent = 'Add to cart · $' + price;
    // Store the variant payload; clicking adds to cart + opens the drawer (handler below).
    // href is only a no-JS fallback to the product page — never the /cart/<id> permalink, which jumps to checkout.
    cta.dataset.cart = opt.dataset.cart || '';
    cta.setAttribute('href', '/products/awear-beta');
  };
  const photo = buy.querySelector('.buy__photo img');
  const deliveryEl = buy.querySelector('[data-delivery]');
  const showMode = (mode) => {
    segs.forEach(s => s.classList.toggle('is-active', s.dataset.mode === mode));
    sets.forEach(s => { s.hidden = s.dataset.set !== mode; });
    if (deliveryEl) deliveryEl.textContent = 'Estimated delivery: early October';
    if (photo) {
      const src = mode === 'patches' ? buy.dataset.imgPatches : buy.dataset.imgDevice;
      if (src && photo.getAttribute('src') !== src) photo.src = src;
    }
    const active = buy.querySelector('.buy__set[data-set="' + mode + '"]');
    selectOpt(active.querySelector('.opt.is-on') || active.querySelector('.opt'));
  };
  buy.querySelectorAll('.opt').forEach(o => o.addEventListener('click', () => selectOpt(o)));
  segs.forEach(s => s.addEventListener('click', () => showMode(s.dataset.mode)));
  // Add the selected bundle to the cart and reveal the drawer — keep the shopper on the page.
  cta.addEventListener('click', (e) => {
    const items = parseCart(cta.dataset.cart);
    if (!items.length || cta.getAttribute('aria-busy') === 'true') return; // no variants -> follow href fallback
    e.preventDefault();
    const label = cta.textContent;
    cta.setAttribute('aria-busy', 'true');
    cta.textContent = 'Adding…';
    addToCart(items)
      .then(() => openCartDrawer(cta))
      .catch(() => { window.location.href = cta.getAttribute('href'); })
      .finally(() => { cta.removeAttribute('aria-busy'); cta.textContent = label; });
  });
  showMode('device');

  // "Order patches" shortcut: switch to the Patches-only tab. The link targets #buy, so the
  // browser's native anchor scroll (same as the other hero buttons) carries the shopper to the
  // configurator. Also honour a ?tab=patches URL for shareable links.
  const selectPatches = () => showMode('patches');
  const scrollToBuy = () => {
    const t = document.getElementById('buy');
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  if (new URLSearchParams(window.location.search).get('tab') === 'patches') {
    selectPatches();
    // Defer the scroll until the hero image + layout have settled; on first paint the
    // target offset is wrong, so a native anchor jump lands at the top of the page.
    const goPatches = () => setTimeout(scrollToBuy, 250);
    if (document.readyState === 'complete') goPatches();
    else window.addEventListener('load', goPatches, { once: true });
  }
  document.querySelectorAll('[data-order-patches]').forEach(el => el.addEventListener('click', selectPatches));
}

// ===== Reviews: filter by category =====
const rfilters = document.querySelectorAll('.review-filter');
if (rfilters.length) {
  const cards = document.querySelectorAll('.quote-card');
  rfilters.forEach(btn => btn.addEventListener('click', () => {
    rfilters.forEach(b => b.classList.toggle('is-active', b === btn));
    const cat = btn.dataset.cat;
    cards.forEach(c => c.classList.toggle('is-hidden', cat !== 'all' && c.dataset.cat !== cat));
  }));
}

// ===== Cart helpers (shared by the configurator, nav and cross-sell) =====
function openCartDrawer(trigger) {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.open === 'function') { drawer.open(trigger || undefined); return true; }
  const bubble = document.querySelector('#cart-icon-bubble, #cart-icon-bubble-sticky');
  if (bubble) { bubble.click(); return true; }
  return false;
}
function closeCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.close === 'function') { try { drawer.close(); return; } catch (e) {} }
  const closer = document.querySelector('cart-drawer .drawer__close, #CartDrawer .drawer__close, .cart-drawer__close, .cart-drawer__overlay');
  if (closer) { closer.click(); return; }
  if (drawer) drawer.classList.remove('active', 'animate', 'is-open');
  document.body.classList.remove('overflow-hidden');
}
// The badge is only rendered server-side when the cart already has items, so create/remove it
// on the fly — otherwise adding from an empty cart leaves the count invisible.
function setCartCount(n) {
  document.querySelectorAll('.nav__cart').forEach(cart => {
    let badge = cart.querySelector('.nav__cart-count');
    if (n > 0) {
      if (!badge) { badge = document.createElement('span'); badge.className = 'nav__cart-count'; cart.appendChild(badge); }
      if (badge.textContent !== String(n)) badge.textContent = n;
    } else if (badge) {
      badge.remove();
    }
  });
}
function refreshCartCount() {
  return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(r => r.json())
    .then(c => { setCartCount(c.item_count); return c; });
}
// "id:qty,id:qty" -> [{id, quantity}, ...]
function parseCart(str) {
  return (str || '').split(',').map(s => s.trim()).filter(Boolean).map(pair => {
    const bits = pair.split(':');
    return { id: Number(bits[0]), quantity: Number(bits[1] || 1) };
  }).filter(it => it.id);
}
// Swap in freshly rendered drawer markup AND keep the empty/filled state class in sync.
// Critical: the theme toggles `is-empty` on <cart-drawer> to show either the items or the
// "your cart is empty" block. Replacing only the inner HTML without syncing that class leaves
// a stale `is-empty` when adding from an empty cart → the new items get hidden → blank drawer.
function renderCartDrawer(html) {
  if (!html) return;
  const live = document.querySelector('cart-drawer');
  if (!live) return;
  const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
  if (!fresh) return;
  live.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
  const freshInner = fresh.querySelector('.drawer__inner');
  const liveInner = live.querySelector('.drawer__inner');
  if (freshInner && liveInner) liveInner.innerHTML = freshInner.innerHTML;
}
// Add items, refresh the drawer, update the nav count.
function addToCart(items) {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items, sections: 'cart-drawer' })
  })
    .then(r => { if (!r.ok) return r.json().then(j => { throw new Error(j.description || 'add failed'); }); return r.json(); })
    .then(data => {
      renderCartDrawer(data.sections && data.sections['cart-drawer']);
      return refreshCartCount();
    });
}

// ===== Cart: clicking the nav cart opens the slide-out drawer instead of the /cart page =====
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.nav__cart');
  if (!trigger) return;
  if (document.querySelector('cart-drawer') ||
      document.querySelector('#cart-icon-bubble, #cart-icon-bubble-sticky')) {
    e.preventDefault();
    openCartDrawer(trigger);
  }
  // else: no drawer present → let href="/cart" load the cart page as a fallback
});

// ===== Cart drawer: clicking a line item / continue / view-cart closes the drawer and goes there =====
// All those links now point at /pages/shop#buy. If we're already on the shop page, a hash-only
// click won't navigate (so the drawer would stay open) — close it and scroll to the kit ourselves.
document.addEventListener('click', function (e) {
  const a = e.target.closest('cart-drawer a');
  if (!a) return;
  const href = a.getAttribute('href') || '';
  if (href.indexOf('/pages/shop') !== 0) return;
  closeCartDrawer();
  if (location.pathname === '/pages/shop') {
    e.preventDefault();
    history.replaceState(null, '', '/pages/shop#buy');
    const target = document.querySelector('#buy');
    if (target) setTimeout(() => target.scrollIntoView({ behavior: 'smooth', block: 'start' }), 90);
  }
  // else: let the browser navigate to /pages/shop#buy (the drawer is already closing)
});

// ===== Cart drawer touch-ups that must survive the drawer's re-renders =====
// (1) The static trust line says "30-day"; our return window is 15 days.
// (2) The empty-cart "Continue shopping" button defaults to /collections/all (the old catalog page);
//     send shoppers to our Order page instead.
// The whole <cart-drawer> node can be swapped on re-render, so watch the entire document.
(function () {
  const patchCartDrawer = () => {
    document.querySelectorAll('.awear-cart__trust').forEach(el => {
      if (el.innerHTML.indexOf('30-day') !== -1) el.innerHTML = el.innerHTML.replace('30-day', '15-day');
    });
    document.querySelectorAll('.cart-drawer__continue-link, .cart-drawer__view-cart-btn, cart-drawer a[href$="/collections/all"], cart-drawer a[href="/cart"]').forEach(a => {
      if (a.getAttribute('href') !== '/pages/shop#buy') a.setAttribute('href', '/pages/shop#buy');
    });
    // (3) Cart line items (product image + title) link to the product/shop page; send those clicks to the kit configurator too.
    document.querySelectorAll('cart-drawer a[href*="/products/"], cart-drawer a[href="/pages/shop"]').forEach(a => {
      if (a.getAttribute('href') !== '/pages/shop#buy') a.setAttribute('href', '/pages/shop#buy');
    });
    // Keep the nav count badge in sync when the drawer re-renders (incl. theme-driven remove / qty change).
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (drawer.classList.contains('is-empty')) { setCartCount(0); }
      else { const m = drawer.textContent.match(/Your Cart\s*\((\d+)\)/); if (m) setCartCount(Number(m[1])); }
    }
  };
  patchCartDrawer();
  document.addEventListener('DOMContentLoaded', patchCartDrawer);
  new MutationObserver(patchCartDrawer).observe(document.documentElement, { childList: true, subtree: true });
})();

// ===== Cart: device cross-sell — AJAX add, then refresh the drawer in place =====
document.addEventListener('click', function (e) {
  const add = e.target.closest('.awear-cart__upsell-add');
  if (!add) return;
  e.preventDefault();
  const id = add.getAttribute('data-variant-id');
  if (!id) return;
  add.disabled = true;
  addToCart([{ id: Number(id), quantity: 1 }])
    .then(() => openCartDrawer(add))
    .catch(() => { window.location.href = '/cart'; })
    .finally(() => { add.disabled = false; });
});

// ===== Footer newsletter — AJAX submit so the page never reloads / scrolls =====
(function () {
  function showMsg(form, text, ok) {
    let p = form.querySelector('.footer__news-msg');
    if (!p) { p = document.createElement('p'); form.appendChild(p); }
    p.className = 'footer__news-msg ' + (ok ? 'footer__news-msg--ok' : 'footer__news-msg--err');
    p.setAttribute('role', ok ? 'status' : 'alert');
    p.textContent = text;
  }
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form.footer__news');
    if (!form) return;
    e.preventDefault();
    const email = form.querySelector('input[type=email]');
    if (!email || !email.value || !email.checkValidity()) { if (email) email.reportValidity(); return; }
    const btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    fetch(form.action.split('#')[0], { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
      .then(() => { showMsg(form, "Thanks! You're on the list.", true); email.value = ''; })
      .catch(() => { showMsg(form, 'Something went wrong. Please try again.', false); })
      .finally(() => { if (btn) btn.disabled = false; });
  });
})();

// Why AWEAR testimonials are now autoplaying (muted) YouTube embeds — no JS sequencing needed.
